/** The `algorithm` property used in `m.room.encrypted` state events for encrypted rooms.
 */
export const MEGOLM_ENCRYPTION_ALGORITHM = "m.megolm.v1.aes-sha2";
